import React, { useState, useRef } from "react";
import "./associates.css";
import { Carousel, Button, Row, Col, Alert } from "antd";
import {
  UsergroupAddOutlined,
  HighlightOutlined,
  BellOutlined,
  UserOutlined,
  HeartOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.css";
import emailjs from "@emailjs/browser";

// Components
import Header from "../../components/Header/index";
import Layout from "antd/lib/layout/layout";
import Featurescard from "../../components/Featurescard";
import Footer from "../../components/Footer";
import ProductCard from "../../components/productCards";
import Teamcard from "../../components/Teamcard";

// Images
import golden from "../../assets/Images/golden.jpg";
import work from "../../assets/Images/work.jpg";
import img from "../../assets/Images/Goldin trout.png";
import lakeTrout from "../../assets/Images/lake.png";
import brownTrout from "../../assets/Images/brown.png";
import goldenfish from "../../assets/Images/golden.png";
import profile from "../../assets/Images/profile.jpg";
import broshallLogo from "../../assets/Images/broshallLogo.jpg";
import CEO from "../../assets/Images/CEO.jpg";
import issa from "../../assets/Images/issa.jpeg";
import abs from "../../assets/Images/abs.jpg";
import construction from "../../assets/Images/construction.jpeg";

import styles from "./styles";

const Associates = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isAlert, setIsAlert] = useState(false);

  const contentStyle = {
    minHeight: "70vh",
    color: "#fff",
    lineHeight: "50px",
    backgroundColor: "#364d79",
  };

  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    setIsLoading(true);
    emailjs
      .sendForm("gmail", "template_6lyko6e", form.current, "PATvzHWWkkW0PXaQ6")
      .then(
        (result) => {
          console.log(result.text);
          setIsLoading(false);
          e.target.reset();
          setIsAlert(true);
          setTimeout(() => {
            setIsAlert(false);
          }, 2000);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div id="home">
      <Header
        brandLogo={broshallLogo}
        brandName="broshall associates GB"
        facebookLink={
          "https://www.facebook.com/Broshall-Associates-Pvt-Ltd-937367283270638"
        }
      />
      {/* Hero Section */}
      <section id="associates">
        <Carousel id="hero">
          <div>
            <div style={contentStyle} className="carouselItem carouselDiv">
              <div className="container">
                <Row gutter={16} className="carousel-row">
                  <Col
                    className="gutter-row"
                    sx={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 18 }}
                  >
                    <Button type="primary" shape="round" size="large">
                      Welcome to Broshall
                    </Button>
                    <h2 className="text-white carouselHeading">
                      Broshall Associates Pvt Ltd Gilgit Baltistan.
                    </h2>
                    <p className="text-white carouselPara">
                      Broshall Associates Pvt Ltd Gilgit Baltistan deals with
                      Government Contractors, Engineers, Builders, Constructors,
                      Property Dealers, Land Developers, Minerals, Minners and
                      General Order Suppliers.
                    </p>
                    <div className="carouselBtns">
                      <Button shape="round" size="large" className="btn1">
                        Learn More
                      </Button>
                      <Button shape="round" size="large" className="btn2">
                        Contact us
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <div>
            <div style={contentStyle} className="carouselItem carouselDiv">
              <div className="container">
                <Row gutter={16} className="carousel-row">
                  <Col
                    className="gutter-row"
                    sx={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 18 }}
                  >
                    <Button type="primary" shape="round" size="large">
                      Welcome to Broshall
                    </Button>
                    <h2 className="text-white carouselHeading">
                      Broshall Associates Pvt Ltd Gilgit Baltistan.
                    </h2>
                    <p className="text-white carouselPara">
                      Broshall Associates Pvt Ltd Gilgit Baltistan deals with
                      Government Contractors, Engineers, Builders, Constructors,
                      Property Dealers, Land Developers, Minerals, Minners and
                      General Order Suppliers.
                    </p>
                    <div className="carouselBtns">
                      <Button shape="round" size="large" className="btn1">
                        Learn More
                      </Button>
                      <Button shape="round" size="large" className="btn2">
                        Contact us
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <div>
            <div style={contentStyle} className="carouselItem carouselDiv">
              <div className="container">
                <Row gutter={16} className="carousel-row">
                  <Col
                    className="gutter-row"
                    sx={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 18 }}
                  >
                    <Button type="primary" shape="round" size="large">
                      Welcome to Broshall
                    </Button>
                    <h2 className="text-white carouselHeading">
                      Broshall Associates Pvt Ltd Gilgit Baltistan.
                    </h2>
                    <p className="text-white carouselPara">
                      Broshall Associates Pvt Ltd Gilgit Baltistan deals with
                      Government Contractors, Engineers, Builders, Constructors,
                      Property Dealers, Land Developers, Minerals, Minners and
                      General Order Suppliers.
                    </p>
                    <div className="carouselBtns">
                      <Button shape="round" size="large" className="btn1">
                        Learn More
                      </Button>
                      <Button shape="round" size="large" className="btn2">
                        Contact us
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Carousel>
      </section>
      <Layout style={{ backgroundColor: "#fff" }}>
        <Row className="container">
          <Col sm={24} style={styles.features}>
            <div>
              <h1 style={styles.choose} className="choose">
                Our Services
              </h1>
              <p style={styles.homePara} className="home-para">
                Explore our Services
              </p>
              <span className="featuresSpan"></span>
            </div>
          </Col>
        </Row>
        <Row className="container" style={{ paddingBottom: "80px" }}>
          <Col xs={24} sm={12} md={12} lg={12} xl={6}>
            <Featurescard
              cardHeading="Contractors"
              bgImage={work}
              cardIcon={<UserOutlined />}
              cardPara="We have the most Experienced team members"
            />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={6}>
            <Featurescard
              cardHeading="Builders"
              bgImage={construction}
              cardIcon={<HighlightOutlined />}
              cardPara="Take a step that is new. We've a loveable spa that needs your face threes company too."
            />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={6}>
            <Featurescard
              cardHeading="Constructors"
              bgImage={construction}
              cardIcon={<BellOutlined />}
              cardPara="Take a step that is new. We've a loveable spa that needs your face threes company too."
            />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={6}>
            <Featurescard
              cardHeading="Property Dealers"
              bgImage={golden}
              cardIcon={<UsergroupAddOutlined />}
              cardPara="Take a step that is new. We've a loveable spa that needs your face threes company too."
            />
          </Col>
        </Row>
      </Layout>

      <section id="aboutus">
        <Layout>
          <Row className="aboutSection">
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="container">
                <div style={styles.aboutusDiv}>
                  <div>
                    <h2 style={styles.choose} className="aboutHeading">
                      About us
                    </h2>
                    <p style={styles.homePara} className="aboutPara">
                      Broshall Associates Pvt Ltd GB deals with Govt.
                      Contructors, Buildings Contructions, Property Dealers,
                      Land Developers, Engineers, Minerals Minners and General
                      Order Suppliers
                    </p>
                    <a href="#" className="aboutLink">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              className="aboutDiv"
            ></Col>
          </Row>
        </Layout>
      </section>

      <Layout>
        <div className="carouselCards">
          <div>
            <Row>
              <Col sm={24} style={styles.features}>
                <div style={{ lineHeight: "50px" }}>
                  <h1
                    style={styles.choose}
                    className="text-white productsHeading"
                  >
                    PRODUCTS FROM General Order Suppliers
                  </h1>
                  <p style={styles.homePara} className="productPara">
                    Explore Our Latest Products For Your Fine Constructons
                  </p>
                </div>
              </Col>
            </Row>
            <Carousel>
              <div style={{ marginBottom: "0px" }}>
                <div style={contentStyle} className="productDiv">
                  <Row
                    className="contain"
                    style={{ paddingBottom: "30px" }}
                    gutter={24}
                  >
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={img}
                        cardHeading="Golden trout"
                        price="$ 45.00/KG"
                        cardBtn="add to cart"
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={lakeTrout}
                        cardHeading="lake trout"
                        price="$ 40.00/KG"
                        cardBtn="add to cart"
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        sale="sale"
                        heart={<HeartOutlined />}
                        image={goldenfish}
                        cardHeading="Golden trout"
                        price="$ 46.30/KG"
                        cardBtn="add to cart"
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={brownTrout}
                        cardHeading="brown trout"
                        price="$ 43.20/KG"
                        cardBtn="add to cart"
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              <div>
                <div style={contentStyle} className="productDiv">
                  <Row
                    className="contain"
                    style={{ paddingBottom: "30px" }}
                    gutter={24}
                  >
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={goldenfish}
                        cardHeading="Golden trout"
                        price="$ 46.30/KG"
                        cardBtn="add to cart"
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={brownTrout}
                        cardHeading="brown trout"
                        price="$ 43.20/KG"
                        cardBtn="add to cart"
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        sale="sale"
                        heart={<HeartOutlined />}
                        image={lakeTrout}
                        cardHeading="lake trout"
                        price="$ 40.00/KG"
                        cardBtn="add to cart"
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={img}
                        cardHeading="Golden trout"
                        price="$ 45.00/KG"
                        cardBtn="add to cart"
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              <div style={{ marginBottom: "0px" }}>
                <div style={contentStyle} className="productDiv">
                  <Row
                    className="contain"
                    style={{ paddingBottom: "30px" }}
                    gutter={24}
                  >
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={img}
                        cardHeading="Golden trout"
                        price="$ 45.00/KG"
                        cardBtn="add to cart"
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={lakeTrout}
                        cardHeading="lake trout"
                        price="$ 40.00/KG"
                        cardBtn="add to cart"
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        sale="sale"
                        heart={<HeartOutlined />}
                        image={goldenfish}
                        cardHeading="Golden trout"
                        price="$ 46.30/KG"
                        cardBtn="add to cart"
                      />
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                      <ProductCard
                        new="new"
                        heart={<HeartOutlined />}
                        image={brownTrout}
                        cardHeading="brown trout"
                        price="$ 43.20/KG"
                        cardBtn="add to cart"
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </Carousel>
            <Row>
              <Col
                sm={24}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "15vh",
                  margin: "0 auto",
                }}
              >
                <button className="allProducts">View all products</button>
              </Col>
            </Row>
          </div>
        </div>
      </Layout>
      <section id="ourteam">
        <Layout style={{ paddingBottom: "150px", paddingTop: "80px" }}>
          <div className="container">
            <Row>
              <Col xs={24} sm={24} lg={24}>
                <div style={styles.ourTeamDiv}>
                  <h2 style={styles.choose}>Meet Our Team</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Teamcard
                  teamHeading="Muhammad Shafa"
                  bgImage={abs}
                  teamPara="ceo"
                />
              </Col>
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Teamcard
                  teamHeading="Muhammad Ismail"
                  bgImage={CEO}
                  teamPara="chairman"
                />
              </Col>
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Teamcard
                  teamHeading="Muhammad Issa"
                  bgImage={issa}
                  teamPara="manager"
                />
              </Col>
              <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <Teamcard
                  teamHeading="Ali Haider"
                  bgImage={profile}
                  teamPara="Accountant"
                />
              </Col>
            </Row>
          </div>
        </Layout>
      </section>

      <section id="contact">
        <Layout>
          <div className="container">
            <Row>
              <Col
                sx={20}
                sm={22}
                md={24}
                lg={24}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "50px",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <h2>Let us hear from you directly!</h2>
                  <p>
                    We always wants to hear from you! Let us know how we can
                    best help you and we'll do our very best.
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="container">
              <Col span="24">
                <form
                  ref={form}
                  onSubmit={sendEmail}
                  autocomplete="off"
                  className="sentEmailForm"
                >
                  <Row>
                    <Col span={24}>
                      <label style={styles.label}>Full Name:</label>
                      <input
                        type="text"
                        name="name"
                        autocomplete="off"
                        style={styles.mesInput}
                        className="loginINput"
                        placeholder="Full Name"
                        required
                      />
                    </Col>
                    <Col span={24}>
                      <label style={styles.label}>Email:</label>
                      <input
                        type="email"
                        name="email"
                        autocomplete="off"
                        style={styles.mesInput}
                        className="loginINput"
                        placeholder="jhondoe@gmail.com"
                        required
                      />
                    </Col>
                    <Col span={24}>
                      <label style={styles.label}>Subject:</label>
                      <input
                        type="text"
                        name="subject"
                        autocomplete="off"
                        style={styles.mesInput}
                        className="loginINput"
                        placeholder="Subject"
                        required
                      />
                    </Col>
                    <Col span={24}>
                      <label style={styles.label}>Message:</label>
                      <textarea
                        rows={5}
                        style={styles.mesTextArea}
                        name="message"
                        placeholder="Type your message..."
                      />
                    </Col>
                    <Col sx={20} sm={22} md={24} lg={24}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="loginBtn"
                      >
                        {isLoading ? (
                          <span>
                            <SyncOutlined spin /> loading
                          </span>
                        ) : (
                          <span>Send Message</span>
                        )}
                      </Button>
                      {isAlert && (
                        <Alert
                          message="Message sent Successfully!"
                          type="success"
                          style={{ marginTop: "20px" }}
                          showIcon
                        />
                      )}
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </div>
        </Layout>
      </section>

      <section id="footer">
        <Layout>
          <Footer />
        </Layout>
      </section>
    </div>
  );
};
export default Associates;
